import { InfoTooltip } from "@goodfill/ui-components";

export const OrderExpirationTimeTableHeader = () => (
  <>
    <InfoTooltip
      text={
        "The expiration date is entered in the EST/EDT time zone. Under date picker you can see the value of the selected expiration date in your current time zone."
      }
    />
    Order Expiration
    <br />
    Date & Time
  </>
);
